import {ResizeSensor} from "css-element-queries";

$(function () {
    // Attach cooldown behaviour to DI form submit button (if we're in the account section)
    const submitButtonElement = document.querySelector('#ats_di_form_container button.next');
    if (submitButtonElement) {
        submitButtonElement.setAttribute('data-cooldown-on-click-duration', '2000');
        submitButtonElement.setAttribute('data-cooldown-on-click-text', 'Updating...');
        submitButtonElement.classList.add('cooldown-on-click-button');
    }

    //DI Form container collapse toggle
    $('.ats_di_form_container_toggle').on('click', function () {
        $('#ats_di_form_container').collapse('toggle');
        $('.ats_di_form_container_toggle').toggleClass('hide');
        
        //Button disable to avoid spamming :p
        $('.ats_di_form_container_toggle').attr('disabled', 'disabled');
        setTimeout(function () {
            $('.ats_di_form_container_toggle').removeAttr('disabled');
        }, 500);
        
        //DI form container description read more/less toggle
        $('#ats_dl_form_container_description').multiTextToggleCollapse({
            line: 5
        });
    });

    $('select.ats_disability_question > option').on('mousedown', function(e) {
        e.preventDefault();
        this.selected = !this.selected;
        const mutuallyExclusiveOptions = ['No known impairment', 'No known impairment, health condition or learning difference', 'Prefer not to say'];
        const options = Array.from(this.parentNode.options);
        let selected = options.filter(option => option.selected).map(option => option.textContent);
        const hasMutuallyExclusiveOption = selected.find(s => mutuallyExclusiveOptions.includes(s));
        if (hasMutuallyExclusiveOption) {
            options.forEach(option => {
                if (option.selected && hasMutuallyExclusiveOption !== option.textContent) {
                    option.selected = false;
                }
            });
        }
    });
    
    //Handle width change for select options display on small devices
    new ResizeSensor($('#ats_di_form_container'), function () {
        let di_select_option = $('.di_dropdown_question option');
        let width            = $('#ats_di_form_container').width();
        $.each(di_select_option, function (index, item) {
            let textMin = $(item).attr('textMin');
            let textMax = $(item).attr('textMax');
            
            if (width < 500) {
                //Attach the title attr
                $(item).attr('title', textMax);
                
                //Truncate the text
                $(item).html(textMin);
                
                //Emulate the title tag (for mobile devices)
                $(item).attr('data-toggle', $(item).attr('title'));
                $(item).attr('data-container', '#tooltip_container');
                $(item).tooltip({
                    container: `#tooltip_container`,
                    title    : textMax,
                    placement: 'top'
                });
            } else {
                $(item).html(textMax);
                if ($(item).attr('title')) {
                    $(item).tooltip('destroy');
                    $(item).removeAttr('title');
                }
            }
        });
    });
    
    //Emulate clicks on selected elements to trigger exclusive values behavior
    $('.ats_disability_question option[selected]').trigger('click');
});
